module.exports = __webpack_public_path__ + "img/celta-de-vigo-logo-icon.ef31ef0c.png";